import styled from "styled-components/macro";

export const NewDocumentCtaContainer = styled.div`
  padding: 0 40px;
  margin-bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 10px;
  height: 40px;
  min-width: 40px;
  white-space: nowrap;
  font-weight: 500;
  font-size: 16px;
  font-family: inherit;
  color: var(--grey-0);
  background-color: transparent;
  border: 2px solid var(--grey-3);
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background-color: var(--menu-color-hover);
    border-color: transparent;
  }

  &:active {
    background-color: var(--menu-color-active);
    border-color: transparent;
  }

  svg {
    path {
      fill: var(--grey-0);
    }
  }
`;
